export default {
	internas: [
		{
			"images":["/images/rv/1.jpg","/images/rv/2.jpg","/images/rv/3.jpg","/images/rv/4.jpg","/images/rv/5.jpg"],
			"area":"Realidad Virtual",
			"descripcion":"Conoce nuestra nueva sala de Realidad Virtual que cuenta con diferentes módulos que te permiten interactuar con el mundo digital disfrutando de experiencias inmersivas, como juegos, simulaciones y mucho más.",
			// "icon":"ExposicionesTemporales.png"
			"icon":"realidadVirtual"
		},
		{
			"images":["/images/arte/2.jpg","/images/arte/3.jpg","/images/arte/5.jpg","/images/arte/6.jpg"],
			"area": "Arte y Maker Space",
			"descripcion":"En esta área podrás echar a volar tu imaginación experimentando con diversas expresiones artísticas. Desde plasmar los colores en un dibujo, participar en una divertida dinámica en el cuarto negro o con otras exhibiciones que te acercarán a la pintura, la música, la escultura y más. Además, encontrarás un espacio destinado a las artesanías típicas, como las figuras de barro y los famosos tenangos.",
			// "icon": "Arte.png"
			"icon":"arteMakerpace"
		},
		{
			"images":["/images/conociendo/1.jpg","/images/conociendo/3.jpg","/images/conociendo/4.jpg","/images/conociendo/5.jpg"],
			"area":"Conociendo mi Mundo",
			"descripcion":"Un espacio creado especialmente para los pequeños de nivel preescolar. Un área donde los chicos tienen como único reto, divertirse a lo grande.",
			// "icon":"Preescolar.png"
			"icon":"conociendoMundo"
		},
		{
			"images":["/images/energia/5.jpg","/images/energia/2.jpg","/images/energia/3.jpg","/images/energia/4.jpg"],
			"area":"Energía",
			"descripcion":"Es un área en la que puedes observar, conocer, experimentar y comprobar en forma divertida, diversas leyes, principios y conceptos científicos, gracias a los cuales se ha podido desarrollar la sorprendente tecnología de nuestros días. Experimenta con la electricidad estática, la inducción electromagnética, imanes y mucho más. Toma el reto de acostarte en una cama de clavos o de sentir la electricidad en el famoso Van de Graff.",
			// "icon":"Ciencia.png"
			"icon":"energia"
		},
		{
			"images":["/images/luzyoptica/1.jpg","/images/luzyoptica/2.jpg","/images/luzyoptica/3.jpg","/images/luzyoptica/4.jpg"],
			"area":"Luz y Óptica",
			"descripcion":"Divierte observando tu imagen distorsionada entre los espejos, jugando con tu sombra o experimentando con las burbujas. Déjate sorprender por las ilusiones ópticas, y observa, conoce, experimenta y comprueba en forma divertida, que sin luz no hay colores.",
			// "icon":"LuzOptica.png"
			"icon":"luzOptica"
		},
		{
			"images":["/images/tecnologia/2.jpg","/images/tecnologia/3.jpg","/images/tecnologia/4.jpg","/images/tecnologia/5.jpg"],
			"area":"Tecnología",
			"descripcion":"Déjate sorprender y entérate, como la ciencia se transforma y trabaja para ti, a través de los principales desarrollos tecnológicos. Desde las máquinas simples hasta la sorprendente robótica; los divertidos videojuegos que te permiten visualizar diferentes escenarios, conocer la realidad virtual, observar el proceso de impresión 3D y por supuesto, en esta área, también se encuentran dispuestos a interactuar contigo los Robots NAO, Dash y Dot.",
			// "icon":"Tecnologia.png"
			"icon":"tecnologia"
		},
		{
			"images":["/images/aguaciencia/2.jpg","/images/aguaciencia/3.jpg","/images/aguaciencia/4.jpg","/images/aguaciencia/5.jpg"],
			"area":"Agua con Ciencia",
			"descripcion":"Déjate sorprender y entérate, como la ciencia se transforma y trabaja para ti, a través de los principales desarrollos tecnológicos. Desde las máquinas simples hasta la sorprendente robótica; los divertidos videojuegos que te permiten visualizar diferentes escenarios, conocer la realidad virtual, observar el proceso de impresión 3D y por supuesto, en esta área, también se encuentran dispuestos a interactuar contigo los Robots NAO, Dash y Dot.",
			// "icon":"Tecnologia.png"
			"icon":"aguaCiencia"
		},
		{
			"images":["/images/universo/2.jpg","/images/universo/3.jpg","/images/universo/4.jpg","/images/universo/5.jpg"],
			"area":"Universo",
			"descripcion":"El sistema solar del que forma parte el planeta Tierra es una pequeña parte de todo el universo, y en esta sala podrás conocer más sobre los planetas, estrellas y el espacio que nos rodea. Asómbrate viendo de cerca un traje espacial, naves y satélites en miniatura, conociendo los modelos de cada planeta y nuestra increíble muestra de meteoritos.",
			// "icon":"Tecnologia.png"
			"icon":"universo"
		},
		{
			"images":["/images/observatorio/1.jpg"],
			"area":"Observatorio",
			"descripcion":"El Observatorio te da la posibilidad de realizar observaciones de diversos cuerpos celestes, como el sol, las estrellas, la luna, algunos planetas, cúmulos y nebulosas, entre otros, además de conocer información básica de astronomía. Contamos con una cúpula electromecánica de 3.8 metros que resguarda en su interior un telescopio reflector marca MEADE LX50, tipo SCHMIDT-CASSEGRAIN de 245 mm de diámetro y de 2500 mm de longitud focal, además de otros telescopios más pequeños. Este servicio se complementa, con un programa de charlas sobre el tema, que se llevan a cabo los jueves a las 20:00 horas, con la participación de la Sociedad Astronómica del Estado de Hidalgo.",
			// "icon":"Observatorio.png"
			"icon":"observatorio"
		},
		{
			"images":["/images/planetario/1.jpg","/images/planetario/2.jpg","/images/planetario/3.jpg"],
			"area":"Planetario",
			"descripcion":"El planetario cuenta con capacidad para 70 visitantes por función, quienes pueden disfrutar de la proyección digital de 18 diferentes y atractivos programas que promueven el estudio de la Astronomía y la Ciencia, con diversas temáticas como El Universo, Arqueo astronomía, y mucho más. Se encuentra equipado con un avanzado sistema integral de proyección para programas multimedia marca Digistar 4 SP2 HD, con el que los asistentes disfrutan plenamente de nuestra programación.",
			// "icon":"Planetario.png"
			"icon":"planetario"
		}	

	],
	externas: [
		{
			"images":["/images/estacion/1.jpg","/images/estacion/2.jpg","/images/estacion/3.jpg"],
			"area":"Estación Temática de Bomberos",
			"descripcion":"Ven a experimentar algunos de los aspectos más relevantes del trabajo que llevan a cabo los bomberos. Conoce la historia del camión autobomba San Mateo, que hoy es parte del acervo de Museo el Rehilete.",
			// "icon":"Bomberos.png"
			"icon":"bomberos"
		},
		{
			"images":["/images/avion/1.jpg","/images/avion/2.jpg","/images/avion/3.jpg","/images/avion/4.jpg"],
			"area":"Avión DC-3",
			"descripcion":"El avión DC3, cuenta con 23 asientos y dos espacios para sillas de ruedas, equipo de sonido, aire acondicionado y 25 gafas de realidad virtual que ofrecen al visitante un video con la historia de este tipo de avión, además de un recorrido virtual por medio de un video de 360 grados, que incluye: pisal del Parque David Ben-Gurión, biblioteca central Ricardo Garibay, teatro Gota de Plata, estadio de futbol y Reloj Monumental de Pachuca y un recorrido por nuestro museo.",
			// "icon":"AviónDC3.png"
			"icon":"avion"
		},
		{
			"images":["/images/dinoparque/1.jpg","/images/dinoparque/2.jpg","/images/dinoparque/3.jpg","/images/dinoparque/4.jpg"],
			"area":"Circuito Dinoparque",
			"descripcion":"En tu recorrido por el Dinoparque conocerás más de 40 figuras en tamaño real de los dinosaurios que habitaron nuestro planeta hace 60 millones de años. Te transportarás a la época prehistórica, mientras aprendes los nombres, características y modos de vida de algunos gigantes de la era mesozoica. Los más pequeños jugarán a ser “paleontólogos”, participando en una excavación para descubrir fósiles de un dinosaurio.",
			// "icon":"Dinoparque.png"
			"icon":"dinoparque"
		},
		{
			"images":["/images/biblioteca/5.jpg","/images/biblioteca/2.jpg","/images/biblioteca/3.jpg","/images/biblioteca/4.jpg"],
			"area":"Biblioteca",
			"descripcion":"Espacio en el que puedes consultar diversos materiales bibliográficos sobre temas de interés general. La biblioteca está incorporada a la Red Estatal y Nacional de Bibliotecas Públicas, con un acervo debidamente clasificado para realizar consultas, además de tener el servicio de préstamo a domicilio.",
			// "icon":"JardinBotanico.png"
			"icon":"biblioteca"
		}
	],
	pruebas: [
		{
			"images":["/images/estacion/1.jpg","/images/estacion/2.jpg","/images/estacion/3.jpg"]

		}
	]
};